<template>

  <v-dialog
    v-model="show"
    persistent
    fullscreen
    >
    <v-card>
      <v-toolbar dense dark color="success">
        Ticket Successful
       </v-toolbar>
        <v-card-text class="pa-4">
            GAME: {{GAMENAME(ticket.game)}} 
            <br/>DRAW: {{ticket.draw_date}}
            <br/>TICKET #: {{ticket.id}}
           
             <br/>TICKET DATE: {{$moment(ticket.transaction_date).format("MMM DD, YYYY hh:mm:ss a")}}
            <br/>
            <table class="va-table print_table3 mt-2 text-left" cellspacing="0">
                      <tr v-for="(item, i) in ticket.ResponseLines" :key="i">
                        <template v-if="ticket.game == '2D' || ticket.game == 'STL'">
                          <td class="font-weight-bold">
                            {{item.num1}} - {{item.num2}} 
                            <!-- <template v-if="item.line_type == 'P2'">
                                {{item.num1}} - {{item.num2}}
                              </template>
                              <template v-if="item.line_type == 'P3'">
                                {{item.num1}} - {{item.num2}} - {{item.num3}}
                              </template>
                              <template v-if="item.line_type == 'P4'">
                                {{item.num1}} - {{item.num2}} - {{item.num3}} - {{item.num4}}
                              </template>
                              <template v-if="item.line_type == 'P5'">
                                {{item.num1}} - {{item.num2}} - {{item.num3}} - {{item.num4}} - {{item.num5}}
                              </template>
                              <template v-if="item.line_type == 'P6'">
                                {{item.num1}} - {{item.num2}} - {{item.num3}} - {{item.num4}} - {{item.num5}} - {{item.num6}}
                              </template> -->

                             <template v-if="item.soldnum.length > 0">
                              <br />
                              <i class="text-warning">Sold Out: 
                                <span v-for="(sold, c) in item.soldnum" :key="c" >
                                  {{sold}}
                                </span>,
                              </i>
                            </template>
                          </td>
                        </template>
                        <template v-else-if="ticket.game == '3D' || ticket.game == '3D-STL-ILOILO-CITY'">
                          <td> 
                            {{item.num1}} - {{item.num2}} - {{item.num3}}
                              <template v-if="item.soldnum.length > 0">
                              <br />
                              <i class="text-warning">Sold Out: 
                                <span v-for="(sold, c) in item.soldnum" :key="c" >
                                  {{sold}}
                                </span>,
                              </i>
                            </template>

                          </td>
                        </template>
                        <template v-else-if="ticket.game == '4D'">
                          <td> {{item.num1}} - {{item.num2}} - {{item.num3}} - {{item.num4}}</td>
                        </template>
                        <td class="text-center"> 
                            <!-- <template v-if="ticket.game == '2D' || ticket.game == 'STL'">
                            <v-chip small label color="success">Tombok: {{$money(item.tombok)}}</v-chip>  <br/>
                            <v-chip small label color="success">Sahud: {{$money(item.sahud)}}</v-chip> 
                          </template> -->
                          <template>
                              {{item.line_type}}
                          </template>
                          </td>
                          <td class="text-right">
                               <span class="text-success">{{$money(item.total_amount)}}</span> <v-chip x-small color="success">Sent</v-chip>
                                <template v-if="$IsNum(item.line_amount)>$IsNum(item.total_amount)">
                                    <br />
                                    <span class="text-error"> {{$money(item.line_amount - item.total_amount)}}</span> <v-chip color="error"  x-small>Sold Out</v-chip>
                                </template>
                          </td>
                      </tr>
                  </table>
                   <v-row no-gutters class="text-primary">
                    <!-- <p class="text-info">No. of draws: {{ticket.drawnum}}</p> -->
                    <v-spacer/>
                    <h4>TOTAL:  {{$money(ticket.amount)}}</h4>
                  </v-row>
                   <v-row no-gutters class="text-primary">
                        <div style="width: 100px; height:100px; margin: auto;">
                             <div id="qrcode_container" class="text-center"></div>
                     </div>
                   </v-row>
        </v-card-text>
        <v-card-actions>
                <v-btn color="success" block  @click="emitToParent('done')">Done</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
    data: () => ({
    }),
    components: {
   // VueQrcode,
  },
  props: {
    show: {
        type: Boolean,
        default: false
    },
    ticket: {
        type: Object,
        default: ()=> { return {} }
    }
  },
  watch:{
     show(v){
          if(v) {
        setTimeout(()=> {
            var qrcode = new window.QRCode(document.getElementById("qrcode_container"), {
            width : 100,
            height : 100
        });
        qrcode.makeCode(this.ticket.id + ':' + this.ticket.code);
     
        }, 100)
           
      } else {
           setTimeout(()=>{
            document.getElementById("qrcode_container").innerHTML = ""
        }, 500)
       
      }
   }
  },
  computed: {
    qrval() {
      return this.ticket.id+":"+this.ticket.code
    },
  },
  methods: {
    emitToParent (action) {
      this.$emit('DialogEvent', action)
    },
    clear() {
        this.ticket = {}
        this.lines = []
    }
  }
}
</script>
